// extracted by mini-css-extract-plugin
module.exports = {"link":"_1NFB0N","default":"weib-d","dark":"M2Y-nx","uppercase":"_2rNkiK"};